import React from 'react';
import styled from 'styled-components/macro';
import {TextTiny} from '@components/elements/TextStyles';
import { Tooltip } from '@mui/material';

type StatusT = null | '' | 'finished' | 'error' | 'pending';
interface PropsI {
  status: StatusT;
}

const statusMap: {[key: string]: {color: string, tip: string}} = {
  'finished': {
    color: '#44ff44',
    tip: 'Analysis Complete'
  },
  'error': {
    color: '#aa2e25',
    tip: 'Error -- please submit bug report'
  },
  'pending': {
    color: '#9e5ab8',
    tip: 'Analysis in Process'
  }
}

const StatusIndicator = (props:PropsI) => {
  const {status} = props;
  if (status === undefined) return null;

  const getLabel = (status:StatusT) => {
    if (status === 'pending') return <TextTiny color={'accent'}>pending</TextTiny>
    return null
  }

  return(
    <StatusIndicatorContainer>
      <Tooltip
        title={statusMap[props.status].tip}
        arrow
      >
        <>
          <StatusButton color={statusMap[props.status].color} />
          { getLabel(props.status)}
        </>
      </Tooltip>
    </StatusIndicatorContainer>
  )
}

export default StatusIndicator;

const StatusIndicatorContainer = styled.div`
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StatusButton = styled.div<{color: string}>`
  display: flex;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(p) => p.color};
  :hover {
    cursor: pointer;
  }
`;